import React, { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useHistory } from "react-router-dom";
import { Tag, Tooltip } from "antd";
import loader from "../../methods/loader";
import Pagination from "react-pagination-js";
import { useSelector } from "react-redux";
import Layout2 from "../../components/global/layout2";

const statusOptions = [
  { value: "", label: "All Statuses" },
  { value: "pending", label: "Pending" },
  { value: "manual_review", label: "Manual Review" },
  { value: "auto_approved", label: "Auto-Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "suspended", label: "Suspended" },
];

const OnboardingQueue = () => {
  const [data, setData] = useState([]);
  const history = useHistory();
  const [total, setTotal] = useState(0);
  const [loaderr, setLoaderr] = useState(false);
  const [stats, setStats] = useState({
    pending: 0,
    auto_approved_today: 0,
    manual_review: 0,
    rejected_week: 0,
  });

  const user = useSelector((state) => state.user);
  const searchState = useSelector((state) => state.search);

  const [filters, setFilter] = useState({
    page: 1,
    count: 20,
    search: "",
    status: "",
    startDate: "",
    endDate: "",
  });

  const ChangeFilter = (e) => {
    setFilter(e);
    getData(e);
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };

  const getStats = () => {
    ApiClient.get("admin/onboarding/stats").then((res) => {
      if (res.success && res.data) {
        setStats({
          pending: res.data.pending || 0,
          auto_approved_today: res.data.auto_approved_today || 0,
          manual_review: res.data.manual_review || 0,
          rejected_week: res.data.rejected_week || 0,
        });
      }
    });
  };

  const getData = (p = {}) => {
    loader(true);
    setLoaderr(true);
    let filter = { ...filters, ...p };
    let params = {};
    Object.keys(filter).forEach((key) => {
      if (filter[key] !== "" && filter[key] !== undefined) {
        params[key] = filter[key];
      }
    });
    ApiClient.get("admin/onboarding/queue", params).then((res) => {
      if (res.success) {
        setData(res?.data?.data || res?.data || []);
        setTotal(res?.data?.total_count || res?.data?.total || 0);
      }
      loader(false);
      setLoaderr(false);
    });
  };

  useEffect(() => {
    getData();
    getStats();
  }, []);

  useEffect(() => {
    if (user && user.loggedIn) {
      setFilter({ ...filters, search: searchState.data });
      getData({ search: searchState.data, page: 1 });
    }
  }, [searchState]);

  const handleSearch = (e) => {
    const val = e.target.value;
    setFilter({ ...filters, search: val, page: 1 });
    clearTimeout(window._onboardingSearchTimeout);
    window._onboardingSearchTimeout = setTimeout(() => {
      getData({ search: val, page: 1 });
    }, 400);
  };

  const getRiskScoreBadge = (score) => {
    if (score === null || score === undefined) return <span>-</span>;
    let color = "#e74c3c";
    let bg = "#fde8e8";
    if (score >= 60) {
      color = "#27ae60";
      bg = "#e6f7ee";
    } else if (score >= 30) {
      color = "#f39c12";
      bg = "#fff7e6";
    }
    return (
      <span
        style={{
          padding: "4px 12px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 600,
          backgroundColor: bg,
          color: color,
        }}
      >
        {score}
      </span>
    );
  };

  const getStatusTag = (status) => {
    const colors = {
      pending: "processing",
      manual_review: "warning",
      auto_approved: "success",
      rejected: "error",
      suspended: "default",
    };
    const labels = {
      pending: "Pending",
      manual_review: "Manual Review",
      auto_approved: "Auto-Approved",
      rejected: "Rejected",
      suspended: "Suspended",
    };
    return (
      <Tag color={colors[status] || "default"}>
        {labels[status] || status || "Pending"}
      </Tag>
    );
  };

  const getCheckIcon = (val) => {
    if (val === "verified" || val === true) return <span style={{ color: "#27ae60" }}>&#10003; Verified</span>;
    if (val === "pending" || val === "submitted") return <span style={{ color: "#f39c12" }}>&#9203; Pending</span>;
    return <span style={{ color: "#e74c3c" }}>&#10007; Not submitted</span>;
  };

  const getAgreementIcon = (val) => {
    if (val === "signed" || val === "active" || val === true) return <span style={{ color: "#27ae60" }}>&#10003; Signed</span>;
    return <span style={{ color: "#e74c3c" }}>&#10007; Not signed</span>;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    var d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const statCards = [
    { label: "Pending Review", value: stats.pending, color: "#3E549D", bg: "#eef1f8" },
    { label: "Auto-Approved Today", value: stats.auto_approved_today, color: "#27ae60", bg: "#e6f7ee" },
    { label: "Manual Review Required", value: stats.manual_review, color: "#f39c12", bg: "#fff7e6" },
    { label: "Rejected This Week", value: stats.rejected_week, color: "#e74c3c", bg: "#fde8e8" },
  ];

  return (
    <Layout2 title="Onboarding Queue" Sidetitle="Onboarding Queue">
      <div className="mainareas new-table-set">
        {/* Stats Row */}
        <div className="row mb-4">
          {statCards.map((card, idx) => (
            <div className="col-md-3 col-sm-6 mb-3" key={idx}>
              <div
                style={{
                  background: card.bg,
                  borderRadius: "8px",
                  padding: "20px",
                  borderLeft: "4px solid " + card.color,
                }}
              >
                <div style={{ fontSize: "13px", color: "#666", marginBottom: "4px" }}>
                  {card.label}
                </div>
                <div style={{ fontSize: "28px", fontWeight: 700, color: card.color }}>
                  {card.value}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Header */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <div className="bids-top mb-2 mb-sm-0">
            <h4>
              Results<span>{total}</span>
            </h4>
          </div>
        </div>

        {/* Filters */}
        <div className="d-flex flex-wrap gap-3 mb-3">
          <div style={{ minWidth: "220px", flex: 1, maxWidth: "350px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search by company name, MC# or DOT#..."
              value={filters.search}
              onChange={handleSearch}
            />
          </div>
          <div>
            <select
              className="form-control"
              value={filters.status}
              onChange={(e) => {
                var val = e.target.value;
                setFilter({ ...filters, status: val, page: 1 });
                getData({ status: val, page: 1 });
              }}
            >
              {statusOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <input
              type="date"
              className="form-control"
              value={filters.startDate}
              onChange={(e) => {
                var val = e.target.value;
                setFilter({ ...filters, startDate: val, page: 1 });
                getData({ startDate: val, page: 1 });
              }}
              placeholder="Start Date"
            />
          </div>
          <div>
            <input
              type="date"
              className="form-control"
              value={filters.endDate}
              onChange={(e) => {
                var val = e.target.value;
                setFilter({ ...filters, endDate: val, page: 1 });
                getData({ endDate: val, page: 1 });
              }}
              placeholder="End Date"
            />
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive table_section new-table">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Company Name</th>
                <th scope="col">MC#</th>
                <th scope="col">DOT#</th>
                <th scope="col">Risk Score</th>
                <th scope="col">Status</th>
                <th scope="col">Insurance</th>
                <th scope="col">Agreement</th>
                <th scope="col">Submitted</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((itm, index) => (
                <tr key={itm.id || itm._id || index}>
                  <td>
                    <div className="user_detail">
                      <div className="user_name">
                        <h4
                          className="user"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            history.push("/carrier-dossier/" + (itm.id || itm._id))
                          }
                        >
                          {itm.company_name || itm.carrier_name || "-"}
                        </h4>
                      </div>
                    </div>
                  </td>
                  <td>{itm.mc_number || "-"}</td>
                  <td>{itm.dot_number || "-"}</td>
                  <td>{getRiskScoreBadge(itm.risk_score)}</td>
                  <td>{getStatusTag(itm.verification_status || itm.status)}</td>
                  <td>{getCheckIcon(itm.insurance_status)}</td>
                  <td>{getAgreementIcon(itm.agreement_status)}</td>
                  <td>{formatDate(itm.createdAt || itm.submitted_at)}</td>
                  <td>
                    <div className="action_icons">
                      <Tooltip placement="top" title="Review">
                        <span
                          className="edit_icon pointer"
                          onClick={() =>
                            history.push("/carrier-dossier/" + (itm.id || itm._id))
                          }
                        >
                          <i className="material-icons pointer edit">visibility</i>
                        </span>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Empty State */}
        {total === 0 && !loaderr ? (
          <div className="no-data">
            <img src="assets/img/no-data.png" alt="No data" />
            No Carriers in Queue
          </div>
        ) : null}

        {/* Pagination */}
        {total > 0 ? (
          <div className="paginationWrapper gap-0">
            <div className="d-flex align-items-center mb-2 mb-sm-0">
              <div className="me-2 user-name-color">Show</div>
              {total > 0 && (
                <div className="dropdown addDropdown chnagesname">
                  <button
                    className="btn btn-primary dropdown-toggle removeBg"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {filters?.count}
                  </button>
                  <div
                    className="dropdown-menu shadow bg_hover"
                    aria-labelledby="dropdownMenuButton"
                  >
                    {[10, 20, 30, 50].map((n) => (
                      <a
                        key={n}
                        className="dropdown-item"
                        onClick={() =>
                          ChangeFilter({ ...filters, count: n, page: 1 })
                        }
                      >
                        {n}
                      </a>
                    ))}
                  </div>
                </div>
              )}
              <div className="ms-2 user-name-color">
                from {total} Carriers
              </div>
            </div>
            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />
          </div>
        ) : null}
      </div>
    </Layout2>
  );
};

export default OnboardingQueue;
